import { useSelector } from 'react-redux'
import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'
import { builderTypeSelector } from 'apps/formsCreationKit/store/selectors/workspaceConfig'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel' 

const PhotoStyleSelect = {
  label: 'Style',
  settingType: 'radioButton',
  updateType: 'entry',
  property: 'original_type_id',
  choices: [
    {
      label: 'Single',
      value: 10,
      additionalProperties: {
        entry_type_id: 20,
        length: 0,
        style: 0,
      },
    },
    {
      label: 'Multiple',
      value: 25,
      additionalProperties: {
        entry_type_id: 119,
        length: 10,
        inserts_page_break_at_the_end: false,
        uses_caption_format: false,
        style: 0,
      },
    },
  ],
  showInput: () => {
    const builderType = useSelector(builderTypeSelector)
    const hiddenTypes = ['easy-form', 'studio']

    if (hiddenTypes.includes(builderType)) return false

    return true
  },
}

const DrawingToggle = {
  label: 'Allow Drawing',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'mask',
  dynamicChoices: ({ mask }) => {
    const yesValues = {
      '10': '10',
      '11': '11',
      '12': '12',
      '00': '10',
      '01': '11',
      '02': '12',
    }
    const noValues = {
      '00': '00',
      '01': '01',
      '02': '02',
      '10': '00',
      '11': '01',
      '12': '02',
    }
    return [
      {
        label: 'No',
        value: noValues[mask] || '00',
      },
      {
        label: 'Yes',
        value: yesValues[mask] || '10',
      },
    ]
  },
  isDisabled: () => {
    const isWebForm = useSelector(builderTypeSelector) === 'web-form'
    return isWebForm
  },
}

export const PhotoStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  PhotoStyleSelect,
  SettingsLabel('Config'),
  RequiredToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
